import { login, getInfo, logout } from '@/api/login'
import { removeToken, setToken } from '@/utils/auth'
import { PermissionLevel } from '@/configs/constants'

const user = {
  state: {
    userId: '',
    token: '',
    name: '',
    avatar: '',
    isAdmin: false,
    info: {},
    roleCname: '',
    permissionLevel: 0,
    sppucAccount: ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_ADMIN: (state, isAdmin) => {
      state.isAdmin = isAdmin
    },
    SET_USERINFO: (state, info) => {
      state.info = info
    },
    SET_ROLECNAME: (state, roleCname) => {
      state.roleCname = roleCname
    },
    SET_PERMISSION_LEVEL: (state, level) => {
      state.permissionLevel = level
    },
    SET_SPPUC_ACCOUNT: (state, value) => {
      state.sppucAccount = value
    },
    RESET_USERINFO: (state) => {
      state.isAdmin = false
      state.permissionLevel = 0
      state.sppucAccount = ''
      // console.log('reset userinfo', state)
    }
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          if (response.code === 200) {
            const result = response.data
            const token = result.token_type + ' ' + result.access_token
            setToken(token)
            commit('SET_TOKEN', token)
            // commit('SET_USERID', result.userId)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    async GetInfo ({ commit, state, getters }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          commit('RESET_USERINFO')
          const result = response.data
          commit('SET_USERID', result.mobilePhone)
          commit('SET_NAME', result.nickName)
          commit('SET_USERINFO', result)
          // commit('SET_AVATAR', result.avatar || '/avatar2.jpg')
          if (result.extentions) {
            for (let i = 0; i < result.extentions.length; i++) {
              if (result.extentions[i].key === 'admin') {
                commit('SET_ADMIN', result.extentions[i].value === 'yes')
              }
              if (result.extentions[i].key === 'roleType') {
                const roleCname = result.extentions[i].value
                commit('SET_ROLECNAME', roleCname)
                const permissionLevel = getters.isTemplate ? PermissionLevel.ANONYM : (PermissionLevel[roleCname] ?? 0)
                commit('SET_PERMISSION_LEVEL', permissionLevel)
              }
              if (result.extentions[i].key === 'sppucAccount') {
                const value = result.extentions[i].value
                commit('SET_SPPUC_ACCOUNT', value)
              }
            }
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        logout(state.token).then(() => {
          commit('SET_USERID', '')
          commit('SET_TOKEN', '')
          commit('SET_NAME', '')
          commit('SET_ADMIN', false)
          commit('SET_USERINFO', {})
          removeToken('ACCESS_TOKEN')
          resolve()
        }).catch(() => {
          commit('SET_USERID', '')
          commit('SET_TOKEN', '')
          commit('SET_NAME', '')
          commit('SET_ADMIN', false)
          commit('SET_USERINFO', {})
          removeToken('ACCESS_TOKEN')
          resolve()
        })
      })
    },
    clearToken ({ commit, state }) {
      return new Promise((resolve) => {
        commit('SET_USERID', '')
        commit('SET_TOKEN', '')
        commit('SET_NAME', '')
        commit('SET_ADMIN', false)
        commit('SET_USERINFO', {})
        removeToken('ACCESS_TOKEN')
        resolve()
      })
    }

  }
}

export default user
